export default __webpack_public_path__ + "static/media/tracking.75fb5fb1.svg";